import { useEffect, useRef } from "react";
import InfoPersoStep1Bloc from "../blocs/info-perso/InfoPersoStep1Bloc";
import { scroll2Top, isMobile } from "../utils/utils";
import GeneralDataProtectionBloc from "../blocs/common/GeneralDataProtectionBloc";

export default function InfoPersoStep1Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Complétez votre identité</h1>
        <p className="text ml-lg-desktop mt-sm ta-justify">Ces informations nous ont été transmises par votre service des ressources humaines.</p>
        <p className="text ml-lg-desktop ta-justify fw-bold" >Nous vous invitons à lui communiquer toute modification éventuelle avant de commencer votre affiliation.</p>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <InfoPersoStep1Bloc/>
        </div>
          <GeneralDataProtectionBloc/>
      </div>
   
    )

}